import React, { useState } from 'react';
import ResourceGrid from './ResourceGrid';
import ResourceFilters from './ResourceFilters';
import ResourceDownload from './ResourceDownload';

const ResourcesPage: React.FC = () => {
  const [selectedType, setSelectedType] = useState('');
  const [selectedFormat, setSelectedFormat] = useState('');
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [selectedResource, setSelectedResource] = useState<string | null>(null);

  const resources = [
    {
      id: 'patient-education-guide',
      title: "Complete Guide to Patient Education",
      description: "Comprehensive guide for implementing effective patient education programs.",
      type: 'guide',
      formats: ['pdf', 'doc', 'md']
    },
    {
      id: 'content-calendar-template',
      title: "Healthcare Content Calendar Template",
      description: "12-month content planning template with healthcare-specific categories.",
      type: 'template',
      formats: ['doc', 'pdf']
    },
    {
      id: 'roi-whitepaper',
      title: "ROI of Patient Education: Whitepaper",
      description: "Research-backed analysis of patient education program ROI.",
      type: 'whitepaper',
      formats: ['pdf', 'md']
    },
    {
      id: 'multilingual-guide',
      title: "Multilingual Patient Communication Guide",
      description: "Best practices for delivering patient education in multiple languages.",
      type: 'guide',
      formats: ['pdf', 'doc']
    },
    {
      id: 'case-study-cardiology',
      title: "Case Study: Cardiology Practice Transformation",
      description: "How a cardiology practice improved patient outcomes with digital education.",
      type: 'case_study',
      formats: ['pdf']
    },
    {
      id: 'patient-feedback-template',
      title: "Patient Feedback Survey Template",
      description: "Customizable templates for gathering patient feedback and measuring satisfaction.",
      type: 'template',
      formats: ['doc', 'pdf']
    }
  ];

  const types = [...new Set(resources.map(r => r.type))];
  const formats = [...new Set(resources.flatMap(r => r.formats))];

  const filteredResources = resources.filter(resource => {
    const matchesType = !selectedType || resource.type === selectedType;
    const matchesFormat = !selectedFormat || resource.formats.includes(selectedFormat);
    return matchesType && matchesFormat;
  });

  const handleDownload = (resourceId: string) => {
    setSelectedResource(resourceId);
    setShowDownloadModal(true);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Healthcare Resources</h1>
        <p className="text-xl text-gray-600">
          Download our professional healthcare content and education resources
        </p>
      </div>

      <ResourceFilters
        types={types}
        formats={formats}
        selectedType={selectedType}
        selectedFormat={selectedFormat}
        onTypeChange={setSelectedType}
        onFormatChange={setSelectedFormat}
      />

      <ResourceGrid
        resources={filteredResources}
        onDownload={handleDownload}
      />

      {showDownloadModal && selectedResource && (
        <ResourceDownload
          resources={[resources.find(r => r.id === selectedResource)!]}
          onClose={() => {
            setShowDownloadModal(false);
            setSelectedResource(null);
          }}
        />
      )}
    </div>
  );
};

export default ResourcesPage;